export default "__VITE_ASSET__bOX$FNyN__"